import {ReactNode, useRef} from 'react';
import {useIntersectionObserver} from '../../../../../../common/useIntersectionObserver.hook';

export function ImageViewerViewerEndWrapper({
  index,
  children,
}: {
  index: number;
  children: ReactNode;
}) {
  const ref = useRef<HTMLDivElement | null>(null);
  const entry = useIntersectionObserver(ref, {});
  const isVisible = !!entry?.isIntersecting;
  return (
    <div ref={ref} data-index={index} data-visible={isVisible}>
      {children}
    </div>
  );
}
